import styled from 'styled-components';

export const FileUploaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 20px;
    border-left: 1px solid #e8e8e8;
    height: 80%;
    padding: 0 25px;
`;

export const InfoTitle = styled.h3`
    font-size: 18px;
    font-weight: bold;
`;

export const InfoDescription = styled.p`
    font-size: 14px; 
`;
